module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"search":"Search","failed-load-data":"Failed to load data"}}')
  delete Component.options._Ctor
}
